import { useRef, useEffect } from 'react';
export const useInterval = (callback, delay, count, endTime) => {
    const savedCallback = useRef();
    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    useEffect(() => {
        const tick = () => {
            if (savedCallback.current !== undefined && typeof savedCallback.current === 'function') {
                // @ts-ignore
                savedCallback.current();
            }
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            if (count === endTime) {
                clearInterval(id);
            }
            return () => clearInterval(id);
        }
        return;
    }, [count, delay]);
};
export const convertToSeconds = (time) => time * 0.001;
export const convertToMilliseconds = (time) => time * 1000;
//# sourceMappingURL=utils.js.map